export type { ContentChartLegendItem } from './ChartLegend';
export { default as ContentChartLegend } from './ChartLegend';
